import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from 'styled-components';
import { NavLinkWithPopover, Logo, ExternalLink, Text } from 'src/packages/core';
import { MainNavWrapper, HeaderLeftPart } from '../Header.styles';
import { ThemeType } from 'src/packages/theme';
import {
  getTradeLinks,
  MarketsLinks,
  MoreLinks,
  BuyCryptoLinks,
} from 'src/packages/common/header/links';
import { config } from 'src/config';

interface Props {
  logoTitle?: string;
  hideMainNav?: boolean;
  convertPlatformEnabled: boolean;
  tradeSpotPlatformEnabled: boolean;
  p2pPlatformEnabled: boolean;
  tradeDerivativesPlatformEnabled: boolean;
  earnPlatformEnabled: boolean;
  theme?: ThemeType;
}

export const HeaderLeftPartWrapper = ({
  logoTitle,
  hideMainNav,
  convertPlatformEnabled,
  tradeSpotPlatformEnabled,
  p2pPlatformEnabled,
  tradeDerivativesPlatformEnabled,
  earnPlatformEnabled,
  theme = 'dark',
}: Props) => {
  const { t } = useTranslation();
  const contextTheme = useTheme();

  return (
    <HeaderLeftPart>
      <Logo theme={'dark'} title={logoTitle} />

      {!hideMainNav && (
        <MainNavWrapper>
          <NavLinkWithPopover
            title={t('header.menu.buy_crypto')}
            links={BuyCryptoLinks}
            theme={theme}
          />
          <NavLinkWithPopover title={t('header.menu.markets')} links={MarketsLinks} theme={theme} />

          {!convertPlatformEnabled && !tradeSpotPlatformEnabled && !p2pPlatformEnabled ? null : (
            <NavLinkWithPopover
              title={t('header.menu.trade')}
              links={getTradeLinks(
                convertPlatformEnabled,
                tradeSpotPlatformEnabled
                // p2pPlatformEnabled
              )}
              theme={theme}
            />
          )}

          {tradeDerivativesPlatformEnabled && (
            <ExternalLink link={config.derivativesUrl}>
              <Text
                text={t('header.menu.derivatives')}
                variant='p2'
                color={contextTheme.colors.palette.white}
              />
            </ExternalLink>
          )}

          {earnPlatformEnabled && (
            <ExternalLink link={config.earnUrl}>
              <Text
                text={t('header.menu.earn')}
                variant='p2'
                color={contextTheme.colors.palette.white}
              />
            </ExternalLink>
          )}

          <ExternalLink link={`${config.coinflareUrl}/affiliate`}>
            <Text
              text={t('header.menu.affiliate')}
              variant='p2'
              color={contextTheme.colors.palette.white}
            />
          </ExternalLink>

          <NavLinkWithPopover title={t('header.menu.more')} links={MoreLinks} theme={theme} />
        </MainNavWrapper>
      )}
    </HeaderLeftPart>
  );
};
